"use client";
import React, { useState } from "react";
import CommonImage from "@/components/common/image/CommonImage";
import { Link } from "lucide-react";
import { FaArrowRight } from "react-icons/fa6";
import HomePageService from "@/services/api/HomeService";
import CommonService from "@/services/api/CommonService";
import { ToastContainer, toast } from "react-toastify";
import { useSelector } from "react-redux";
import ContactForm from "./components/ContactForm";

export default function Contact() {
  const setting = useSelector((state) => state.setting.data);

  return (
    <>
      <ToastContainer />

      <section className="contact-us_section section_padding">
        <div className="container">
          <div className="contact-us-card card-48">
            <div className="grid grid-cols-12 gap-6">
              <div className="lg:col-span-5 col-span-12">
                <div className="contact-details-part">
                  <div className="top-title">
                    <CommonImage
                      src={"/images/login/login-title.avif"}
                      className="top-icon"
                      alt="icon"
                    />
                    <span className="text-[#101828] [.dark_&]:text-d-white font-medium text-base">
                      যোগাযোগ করো
                    </span>
                  </div>
                  <h2 className="main-title">
                    {setting?.site_title}{" "}
                    <span className="text-light">
                      একটি বিশ্বস্ত একাডেমিক কোচিং সেন্টার
                    </span>{" "}
                  </h2>
                  <div className="contact-list-wrap">
                    {setting && (
                      <div className="contact-list-item">
                        <div className="empty">
                          <div className="icon-wrap">
                            <CommonImage
                              src={"/images/icon/phone-call.avif"}
                              className="icon"
                              alt="icon"
                            />
                          </div>
                        </div>
                        <h3 className="text">
                          <span className="text-bold">ফোনঃ </span>
                          <a href={`tel:${setting?.phone_1}`} className="link">
                            {setting?.phone_1}
                          </a>
                        </h3>
                      </div>
                    )}{" "}
                    {setting && (
                      <div className="contact-list-item">
                        <div className="empty">
                          <div className="icon-wrap">
                            <CommonImage
                              src={"/images/icon/gmail.avif"}
                              className="icon"
                              alt="icon"
                            />
                          </div>
                        </div>
                        <h3 className="text">
                          <span className="text-bold">ইমেইলঃ </span>
                          <a
                            href={`mailto:${setting.email_1}`}
                            className="link"
                          >
                            {setting.email_1}
                          </a>
                        </h3>
                      </div>
                    )}
                    {setting && (
                      <div className="contact-list-item">
                        <div className="empty">
                          <div className="icon-wrap">
                            <CommonImage
                              src={"/images/icon/timer.avif"}
                              className="icon"
                              alt="icon"
                            />
                          </div>
                        </div>
                        <h3 className="text">
                          <span className="text-bold">অফিস সময়ঃ </span>{" "}
                          {setting?.office_hour}
                        </h3>
                      </div>
                    )}
                    {setting && (
                      <div className="contact-list-item">
                        <div className="empty">
                          <div className="icon-wrap">
                            <CommonImage
                              src={"/images/icon/g-map.avif"}
                              className="icon"
                              alt="icon"
                            />
                          </div>
                        </div>
                        <h3 className="text">
                          <span className="text-bold">লোকেশনঃ </span>{" "}
                          {setting?.address}
                        </h3>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
